"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BarcodeScannerHandler_1 = require("../../Services/BarcodeScannerHandler");
var ScannerInput_1 = require("../../Services/ScannerInput");
var CalibrationFunctions_1 = require("../../Services/CalibrationFunctions");
var Types_1 = require("../../Types");
var reactstrap_1 = require("reactstrap");
var CalibrationImage_1 = require("./Components/CalibrationImage");
var CalibrationResults_1 = require("./Components/CalibrationResults");
var TickImage = require("Assets/Images/tick.png");
var ErrorImage = require("Assets/Images/error.png");
var WarningImage = require("Assets/Images/warning.png");
require("./Styles/CalibrateScanner.css");
var Util_1 = require("../../Services/Util");
var AuthenticationService_1 = require("../../Services/AuthenticationService");
var EventHandlerService_1 = require("../../Services/EventHandlerService");
var History_1 = require("../../Utils/History");
var Endpoints_1 = require("../../Utils/Endpoints");
var CalibrateScannerStatus;
(function (CalibrateScannerStatus) {
    CalibrateScannerStatus[CalibrateScannerStatus["Initial"] = 0] = "Initial";
    CalibrateScannerStatus[CalibrateScannerStatus["Scanning"] = 1] = "Scanning";
    CalibrateScannerStatus[CalibrateScannerStatus["Success"] = 2] = "Success";
    CalibrateScannerStatus[CalibrateScannerStatus["Error"] = 3] = "Error";
})(CalibrateScannerStatus || (CalibrateScannerStatus = {}));
var CalibrateScanner = /** @class */ (function (_super) {
    __extends(CalibrateScanner, _super);
    function CalibrateScanner(props) {
        var _this = _super.call(this, props) || this;
        _this.postCalibrate = function (dom3KeyboardEventCodeSupport) {
            if (_this.responseToken !== undefined && _this.responseToken != null) {
                _this.responseToken.BitmapImage = null;
                if (dom3KeyboardEventCodeSupport) {
                    _this.responseToken.ScannedData = _this.barcodeScannerHandler.scannerInput.getInput();
                }
                else {
                    _this.responseToken.ScannedData = _this.barcodeScannerHandler.scannerInput.getInputBytes();
                }
                var germanPackTestOn = _this.state.germanPackTestOn;
                CalibrationFunctions_1.fetchCalibrate(_this.responseToken, germanPackTestOn, dom3KeyboardEventCodeSupport)
                    .then(function (response) {
                    _this.responseToken = JSON.parse(response);
                    if (_this.responseToken !== undefined) {
                        _this.lastCalibrationToken = _this.responseToken.CalibrationToken;
                        if (_this.responseToken.CalibrationToken.Remaining > 0) {
                            _this.postNextCalibrationBarcode();
                            _this.setState({
                                status: CalibrateScannerStatus.Scanning
                            });
                        }
                        else {
                            _this.displayResults();
                        }
                    }
                    else {
                        _this.displayResults();
                    }
                }, function (error) {
                    console.error(error);
                    _this.displayResults();
                })
                    .catch(function (err) { return console.error(err); });
            }
        };
        _this.displayResults = function () {
            var newResultsProps = __assign(__assign({}, _this.state.resultsProps), { errors: _this.lastCalibrationToken.Errors, warnings: _this.lastCalibrationToken.Warnings, information: _this.lastCalibrationToken.Information });
            var newImageProps = __assign(__assign({}, _this.state.imageProps), { height: 104, width: 104, url: (newResultsProps.errors.length > 0 ? ErrorImage : newResultsProps.warnings.length > 0 ? WarningImage : TickImage) });
            _this.setState({
                imageProps: newImageProps,
                resultsProps: newResultsProps,
                status: (!_this.state.resultsProps.errors || _this.state.resultsProps.errors.length === 0) ? CalibrateScannerStatus.Success : CalibrateScannerStatus.Error,
                remainingBarcodesText: ""
            });
            _this.barcodeScannerHandler.scannerInput = new ScannerInput_1.ScannerInput("!\"%&'()*+,-./0123456789:;<=>?ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz]" + String.fromCharCode(29));
            _this.responseToken = null;
        };
        _this.clearData = function () {
            // TODO: Clear array here?
            _this.responseToken = null;
            //this.lastCalibrationToken = null;
            _this.postNextCalibrationBarcode();
            _this.setState({
                resultsProps: new CalibrationResults_1.CalibrationResultsProps(),
                status: CalibrateScannerStatus.Initial
            });
        };
        _this.saveMapping = function () {
            Util_1.postJson("/ScannerCalibration/SaveCalibrationData", JSON.stringify(_this.lastCalibrationToken.CalibrationData), undefined, true, new Util_1.UserRequestHeaders(__assign(__assign({}, AuthenticationService_1.Auth.getUser()), { Location: _this.props.applicationData.selectedLocation })))
                .then(function (response) {
                if (response) {
                    _this.props.applicationData.updateCallback("calibrationData", _this.lastCalibrationToken.CalibrationData);
                    EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteInformationEvent(_this.props.applicationData.resources.Calibration_CompleteMessage, _this.props.applicationData.resources.Calibration_CompleteTitle, [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Calibration_ReturnToDashboard, "primary", function (currentEvent, closeModalCallback) {
                            _this.updateStoredCalibrationData();
                            closeModalCallback(function () { return History_1.default.push("/Dashboard/Safe"); });
                        }),
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Ok, "secondary", function (currentEvent, closeModalCallback) {
                            _this.updateStoredCalibrationData();
                            closeModalCallback();
                        })
                    ]));
                }
            }).catch(function (reason) {
                console.error("Echo catch: " + reason);
            });
        };
        _this.updateStoredCalibrationData = function () {
            Util_1.getJson(Endpoints_1.default.GetCalibrationData, undefined, true, new Util_1.UserRequestHeaders(__assign(__assign({}, AuthenticationService_1.Auth.getUser()), { Location: _this.props.applicationData.selectedLocation })))
                .then(function (response) {
                var value = JSON.parse(response);
                _this.props.applicationData.updateCallback("calibrationData", value);
            }).catch(function (reason) { return console.error("Error updating calibration data with reason: " + reason); });
        };
        _this.calibrationTitle = function () {
            switch (_this.state.status) {
                case CalibrateScannerStatus.Initial:
                case CalibrateScannerStatus.Scanning:
                    return _this.props.applicationData.resources.CalibrateScanner;
                case CalibrateScannerStatus.Success:
                    return _this.props.applicationData.resources.CalibrationSuccessTitle;
                case CalibrateScannerStatus.Error:
                    return _this.props.applicationData.resources.CalibrationErrorTitle;
            }
        };
        _this.calibrationMessage1 = function () {
            switch (_this.state.status) {
                case CalibrateScannerStatus.Initial:
                case CalibrateScannerStatus.Scanning:
                    return _this.props.applicationData.resources.CalibrateScannerMessage1;
                case CalibrateScannerStatus.Success:
                    return _this.props.applicationData.resources.CalibrationSuccessMessage1;
                case CalibrateScannerStatus.Error:
                    return _this.props.applicationData.resources.CalibrationErrorMessage1;
            }
        };
        _this.calibrationMessage2 = function () {
            switch (_this.state.status) {
                case CalibrateScannerStatus.Initial:
                case CalibrateScannerStatus.Scanning:
                    return _this.props.applicationData.resources.CalibrateScannerMessage2;
                case CalibrateScannerStatus.Success:
                    return _this.props.applicationData.resources.CalibrationSuccessMessage2;
                case CalibrateScannerStatus.Error:
                    return _this.props.applicationData.resources.CalibrationErrorMessage2;
            }
        };
        _this.state = {
            imageProps: {},
            resultsProps: new CalibrationResults_1.CalibrationResultsProps(),
            status: CalibrateScannerStatus.Initial,
            remainingBarcodesText: "",
            germanPackTestOn: false
        };
        _this.responseToken = null;
        _this.lastCalibrationToken = null;
        _this.barcodeScannerHandler = new BarcodeScannerHandler_1.BarcodeScannerHandler(_this.postCalibrate.bind(_this));
        return _this;
    }
    CalibrateScanner.prototype.componentDidMount = function () {
        this.responseToken = null;
        document.addEventListener("keypress", this.barcodeScannerHandler.keyPressHandler, true);
        document.addEventListener("keydown", this.barcodeScannerHandler.keyDownHandler, true);
        document.addEventListener("keyup", this.barcodeScannerHandler.keyUpHandler, true);
        this.postNextCalibrationBarcode();
    };
    CalibrateScanner.prototype.componentWillUnmount = function () {
        document.removeEventListener("keypress", this.barcodeScannerHandler.keyPressHandler, true);
        document.removeEventListener("keydown", this.barcodeScannerHandler.keyDownHandler, true);
        document.removeEventListener("keyup", this.barcodeScannerHandler.keyUpHandler, true);
    };
    CalibrateScanner.prototype.postNextCalibrationBarcode = function () {
        var _this = this;
        if (this.responseToken != null) {
            this.responseToken.BitmapImage = null;
        }
        var smallBarcode = this.barcodeScannerHandler.browser.name === "Edge";
        var newImageProps = __assign(__assign({}, this.state.imageProps), { width: smallBarcode ? 48 : 100, height: smallBarcode ? 48 : 100 });
        var newRemainingBarcodeText = this.state.remainingBarcodesText;
        CalibrationFunctions_1.fetchNextCalibrationBarcode(this.responseToken, this.state.germanPackTestOn, smallBarcode)
            .then(function (response) {
            _this.responseToken = JSON.parse(response);
            if (_this.responseToken === undefined) {
                _this.displayResults();
                newImageProps.url = "";
                return null;
            }
            newRemainingBarcodeText = _this.props.applicationData.resources.RemainingBarcodeMessage1 + " " + (_this.responseToken.CalibrationToken.Remaining + 1) + " " + _this.props.applicationData.resources.RemainingBarcodeMessage2;
            newImageProps.url = "data:image/png;base64," + _this.responseToken.BitmapImage;
            if (!_this.responseToken.BitmapImage) {
                console.error("Failed to retrieve calibration barcode.");
            }
        }, function (error) {
            console.error(error);
            _this.displayResults();
            newImageProps.url = "";
        })
            .finally(function () {
            _this.setState({
                imageProps: newImageProps,
                remainingBarcodesText: newRemainingBarcodeText
            });
        });
    };
    ;
    CalibrateScanner.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Row, null,
            React.createElement(reactstrap_1.Col, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, null,
                        React.createElement("h1", null, this.calibrationTitle()),
                        React.createElement("p", null,
                            " ",
                            this.calibrationMessage1()),
                        React.createElement("p", null,
                            " ",
                            this.calibrationMessage2()))),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { className: "calibration-image-container" },
                        React.createElement(CalibrationImage_1.CalibrationImage, __assign({}, this.state.imageProps))),
                    React.createElement(reactstrap_1.Col, { className: "calibration-image-decriptor-container" },
                        React.createElement("p", null,
                            React.createElement("span", { className: "remainingMessage", id: "remainingBarcodes" }, this.state.remainingBarcodesText)),
                        React.createElement("div", { hidden: this.state.status != CalibrateScannerStatus.Initial },
                            React.createElement(reactstrap_1.CustomInput, { type: "checkbox", id: "exampleCustomCheckbox", onChange: function (e) { _this.setState({ germanPackTestOn: e.currentTarget.checked }, function () { _this.clearData(); }); }, checked: this.state.germanPackTestOn, label: this.props.applicationData.resources.OptionalCalibrationLabel })),
                        React.createElement(CalibrationResults_1.CalibrationResults, __assign({}, this.state.resultsProps)))),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { className: "save-btn-container", hidden: this.state.status !== CalibrateScannerStatus.Success },
                        React.createElement(reactstrap_1.Button, { onClick: this.saveMapping, id: "saveButton", size: "lg", color: "primary" },
                            " ",
                            this.props.applicationData.resources.Save,
                            " ")),
                    React.createElement(reactstrap_1.Col, { className: "reset-btn-container" },
                        React.createElement(reactstrap_1.Button, { hidden: this.state.status == CalibrateScannerStatus.Initial, onClick: this.clearData, id: "resetButton", size: "lg" },
                            " ",
                            this.props.applicationData.resources.CancelScan))))));
    };
    return CalibrateScanner;
}(React.Component));
exports.CalibrateScanner = CalibrateScanner;
//# sourceMappingURL=CalibrateScanner.js.map